import React, { useState, useEffect, useCallback } from "react";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import Header from "../../ShareElements/ContentHeader/ContentHeader";
import Up from "../../../../../Assets/Images/up.svg";
import { NavLink } from "react-router-dom";
import Pencil from "../../../../../Assets/Images/pencil.svg";
import Chat from "../../../../../Assets/Images/chat.svg";
import Delete from "../../../../../Assets/Images/delete.svg";
import MessageIcon from "../../../../../Assets/Images/message-circle.svg";
import Close from "../../../../../Assets/Images/x.svg";
import EmptyState from "../../../../../Assets/Images/EmptyState.svg";
import Plus from "../../../../../Assets/Images/ButtonPlus.svg";
import TextInput from "../../ShareElements/TextInput/SimpleTextInput";
import TextArea from "../../ShareElements/TextInput/SimpleTextArea";
import DesktopOnlyOverlay from "../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import { Config } from "../../../../../Config";
import axios from "axios";
import DeleteAlert from "../../ShareElements/Alert/Alert";
import SearchInput from "../../ShareElements/TextInput/SearchInput";
import MultiSelect from "../../ShareElements/Select/MultiSelect";
import TableFilter from "../../ShareElements/TableFilter/TableFilter";
import MultipleDeleteAlert from "../../ShareElements/Alert/MultipleItemDeleteAlert";
import Collapsible from "react-collapsible";
import MessageModal from "./Components/MessageModal";
import Select from "../../ShareElements/Select/Select";
import PaginationRowSelector from "../Components/PaginationRowSelector";

const UserManagement = (props) => {
  const [Users, setUsers] = useState([]);
  const [ItemIDs, setItemIDs] = useState([]); // used for checkboxes
  const [Pages, setPages] = useState([]);
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [UserToContact, setUserToContact] = useState({});
  const [TotalElements, setTotalElements] = useState();
  // *filter data with initial values* //
  const [Size] = useState(5);
  const [IsActive, setIsActive] = useState(true);
  const [NameLike, setNameLike] = useState("");
  const [Direction, setDirection] = useState("ASC");
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [Start, setStart] = useState(0);
  // ** //
  const [SendMessageIsOpen, setMessageModalIsOpen] = useState(false);
  const [UserIdToDelete, setUserToDelete] = useState("");
  const [AllIds, setAllIds] = useState([]);
  const [SelectedItems, setSelectedItems] = useState([]);
  const [DeleteMultipleIsOpen, setDeleteMultipleIsOpen] = useState(false);
  const [Profiles, setProfiles] = useState([]);
  const [PrevId, setPrevId] = useState("");
  const [ModalPrevId, setModalPrevId] = useState("");
  const [SelectedProfiles, setSelectedProfiles] = useState([]);
  const [UserUUID] = useState(window.localStorage.getItem("UserUUID"));
  const [MessageToAllIsOpen, setMessageToAllIsOpen] = useState(false);
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [SelectedSize, setSelectedSize] = useState(5);
  useEffect(() => {
    getInitialUsersList();
    fetchAllProfiles();
    window.localStorage.removeItem("HasUMvalidationError");
    window.localStorage.removeItem("HasUnsaveChanges");
  }, []);
  useEffect(() => {
    updatePagination();
  }, [TotalElements]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchAllProfiles = () => {
    var Data = JSON.stringify({
      size: 100,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });

    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Profiles = [];
        Res.data.results.map((Item) => {
          Profiles.push({
            name: Item.name,
            id: Item.id,
          });
        });
        setProfiles(Profiles);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getInitialUsersList = () => {
    setStart(0);
    document.getElementById("clear-btn").click();
    let Data = JSON.stringify({
      criteria: null,
      size: Size,
      sorts: [
        {
          direction: Direction,
          fieldName: "firstName",
        },
      ],
      start: 0,
    });

    let Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUsers(Res.data.results);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }
        setTotalElements(Res.data.totalElements);
        let IDs = [];
        Res.data.results.map((Item) => {
          IDs.push(Item.id);
        });
        setItemIDs(IDs);
        createPagination(Res.data.totalElements);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const updatePagination = () => {
    let Count = Math.ceil(TotalElements / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const createPagination = (TotalCount) => {
    let Count = Math.ceil(TotalCount / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };

  // * This function used for fetching filtered data from the server
  // * Parameters based on backend and renamed and stored as component state
  //   respectively as below:
  // size (Int): number of elements displayed in the page
  // enabled(boolean): active or inactive status (our values are 2 for false, 1 for true and 0 for null)
  // nameLike (string): a string value to search names
  // direction (string) : is either DESC (decending) or ASC (ascending)
  // start (Int): the index of the starting page (current page usually)
  const getFilteredData = (Size, ProfilesList, Start) => {
    var Data = {
      criteria: {
        nameLike: document.getElementById("search-input").value,
      },
      size: Size,
      start: parseInt(document.getElementById("Start").value),
      sorts: [{ direction: Direction, fieldName: "firstName" }],
    };

    let SelectedItems = [];
    Profiles.map((Profile) => {
      if (document.getElementById("icon-" + Profile.id).classList.length > 1) {
        SelectedItems.push(Profile.id);
      }
    });
    Data.criteria.roles = SelectedItems;
    if (SelectedItems.length === 0) {
      Data.criteria.roles = null;
    }

    if (
      document.getElementById("icon-" + translateText("inactive")) &&
      document.getElementById("icon-" + translateText("inactive")).classList
        .length === 2 &&
      document.getElementById("icon-" + translateText("active")).classList
        .length === 1
    ) {
      Data.criteria.enabled = false;
    } else if (
      document.getElementById("icon-" + translateText("active")) &&
      document.getElementById("icon-" + translateText("active")).classList
        .length === 2 &&
      document.getElementById("icon-" + translateText("inactive")).classList
        .length === 1
    ) {
      Data.criteria.enabled = true;
    } else {
      delete Data.criteria.enabled;
    }

    if (
      document.getElementById("Identity-pointer-up").classList.length > 1 ||
      document.getElementById("Identity-pointer-down").classList.length > 1
    ) {
      if (document.getElementById("Identity-pointer-up").classList.length > 1) {
        Data.sorts[0].fieldName = "firstName";
        Data.sorts[0].direction = "DESC";
      } else {
        Data.sorts[0].fieldName = "firstName";
        Data.sorts[0].direction = "ASC";
      }
    } else {
      if (document.getElementById("Status-pointer-up").classList.length > 1) {
        Data.sorts[0].fieldName = "enabled";
        Data.sorts[0].direction = "DESC";
      } else {
        Data.sorts[0].fieldName = "enabled";
        Data.sorts[0].direction = "ASC";
      }
    }

    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(Data),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }
        setUsers(Res.data.results);
        setTotalElements(Res.data.totalElements);
        createPagination(Res.data.totalElements);
        let IDs = [];
        Res.data.results.map((Item) => {
          IDs.push(Item.id);
        });
        setItemIDs(IDs);
        if (Res.data.results.length > 0) {
          updatePaginationActiveClass(document.getElementById("PrevId").value);
        }
        if (Data.start === 0 && Data.criteria.nameLike.length > 0) {
          setTimeout(() => {
            if (document.getElementById("1-page-btn")) {
              document.getElementById("1-page-btn").click();
            }
          }, 1000);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const openModal = (i) => {
    setModalPrevId(i)
    if (document.getElementById("modal-" + i).style.display === "block") {
      document.getElementById("modal-" + i).style.display = "none";
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
  };
  const closeMessage = () => {
    setMessageModalIsOpen(false);
  };
  const openMessage = (id, name, email) => {
    console.log(id, name);
    openModal(id);
    setUserToContact({
      name: name,
      id: id,
      email: email,
    });
    setMessageModalIsOpen(true);
  };
  //validates message modal entries
  const validateMessageEntries = () => {
    let Subject = document.getElementById("message-subject").value;
    let Message = document.getElementById("message").value;
    if (Subject.length === 0 || Message.length === 0) {
      if (Subject.length === 0) {
        document
          .getElementById("message-subject-label-holder")
          .classList.add("wrong");
      }
      if (Message.length === 0) {
        document
          .getElementById("message-textarea-holder")
          .classList.add("wrong");
      }
    } else {
      sendMessage(Subject, Message);
    }
  };
  const removeError = (id) => {
    document.getElementById(id).classList.remove("wrong");
  };
  const sendMessage = (Subject, MessageText) => {
    let Message = {
      subject: Subject,
      description: MessageText,
      email: UserToContact.email,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/message",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(Message),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMessageModalIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleDeleteSingle = (User) => {
    openModal(ModalPrevId);
    console.log(User);
    setDeleteIsOpen(true);
    setUserToDelete(User.id);
  };
  const acceptDelete = () => {
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify({ id: UserIdToDelete }),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        deselectCheckboxes();
        getFilteredData(SelectedSize, SelectedProfiles);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
    setDeleteIsOpen(false);
  };
  const cancelDelete = () => {
    setDeleteIsOpen(false);
  };
  const filterByNameLike = () => {
    setNameLike(document.getElementById("search-input").value);
    getFilteredData(SelectedSize, SelectedProfiles);
  };
  const filterByName = () => {
    document
      .getElementById("Status-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Status-pointer-down")
      .classList.remove("active-filter");
    if (Direction === "DESC") {
      setDirection("ASC");
      getFilteredData(SelectedSize, SelectedProfiles);
    } else {
      setDirection("DESC");
      getFilteredData(SelectedSize, SelectedProfiles);
    }
  };
  const filterByStatus = () => {
    document
      .getElementById("Identity-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Identity-pointer-down")
      .classList.remove("active-filter");
    getFilteredData(SelectedSize, SelectedProfiles);
  };
  const addActiveState = () => {
    document.getElementById("clear-btn").style.display = "block";
    document.getElementById("input-icon").style.color = "#6DA2F2";
    document.getElementById("search-placeholder").classList.add("translated");
  };
  const removeActiveState = () => {
    document.getElementById("clear-btn").style.display = "none";
    document.getElementById("input-icon").style.color = "#DDE2EB";
    document
      .getElementById("search-placeholder")
      .classList.remove("translated");
  };
  const clearSearch = () => {
    removeActiveState();
    setNameLike("");
    document.getElementById("search-input").value = "";
    getFilteredData(SelectedSize, SelectedProfiles);
  };
  const handleListByStatus = () => {
    document.getElementById("Start").value = 0;
    let SelectedStatuses = Array(
      document.getElementById("Status-filter").value
    );
    if (SelectedStatuses.length === 2 || SelectedStatuses.length === 3) {
      document.getElementById("Status").value = "0";
    } else if (
      SelectedStatuses.length === 1 &&
      SelectedStatuses[0] === translateText("active")
    ) {
      document.getElementById("Status").value = "1";
    } else if (
      SelectedStatuses.length === 1 &&
      SelectedStatuses[0] == translateText("inactive")
    ) {
      document.getElementById("Status").value = "2";
    } else {
      setIsActive(undefined);
    }
    getFilteredData(SelectedSize, true);
  };
  // this function creates a list (array) of selected profiles ids
  // and sets it in a variable (SelectedProfiles)
  // variable. it is used inside getFilteredData()
  const handleListByProfile = () => {
    document.getElementById("Start").value = 0;
    getFilteredData(SelectedSize, true);
  };

  // our search filter has a feature where we display a clear button inside the field when the user
  // enters a value to search alongside with its active state, this function is called on the change
  // of our search field and it checks the input value and shows the button. searching functionality
  // will be added later. This function receives e which stands for event initiated by the user, it is
  //  where the search value comes from.
  const updateSearchState = (e) => {
    document.getElementById("Start").value = 0;
    let SearchValue = e.target.value;
    if (SearchValue.length > 0) {
      addActiveState();
      setNameLike(SearchValue);
      getFilteredData(SelectedSize, SelectedProfiles, 0);
    } else {
      removeActiveState();
      setNameLike("");
      getFilteredData(SelectedSize, SelectedProfiles, 0);
    }
  };
  // In this function, we check if the user has previously selected all items checkbox or not, then act
  // accordingly, where we select the unchecked items based on their ID which is their index inside the
  // array plus the string "checkbox-" like "checkbox-1" and so on, then we enable the delete button if
  // there are checked elements.
  const checkAll = () => {
    let PrevItems = [...SelectedItems];
    if (document.getElementById("checkbox-all").checked) {
      document.getElementById("delete-btn").classList.remove("disabled");
      for (let i = 0; i < ItemIDs.length; i++) {
        if (
          !document
            .getElementById("checkbox-" + ItemIDs[i])
            .classList.contains("disabled-checkbox")
        ) {
          PrevItems.push(ItemIDs[i]);
          document.getElementById("checkbox-" + ItemIDs[i]).checked = true;
        }
      }
      setSelectedItems(PrevItems);
    } else {
      deselectCheckboxes();
    }
  };
  const handleItemSelect = (Item) => {
    let ItemIsChecked = document.getElementById("checkbox-" + Item).checked;
    if (ItemIsChecked) {
      SelectedItems.push(Item);
    } else {
      SelectedItems.splice(SelectedItems.indexOf(Item), 1);
    }
    if (SelectedItems.length < 1) {
      disableDelete();
    } else {
      enableDelete();
    }
  };
  const enableDelete = () => {
    document.getElementById("delete-btn").classList.remove("disabled");
  };
  const disableDelete = () => {
    document.getElementById("delete-btn").classList.add("disabled");
  };
  const deleteMultipleItems = () => {
    setDeleteMultipleIsOpen(true);
  };
  const acceptDeleteMultiple = () => {
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        ids: SelectedItems,
      }),
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteMultipleIsOpen(false);
        getFilteredData(SelectedSize, SelectedProfiles);
        deselectCheckboxes();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const cancelDeleteMultiple = () => {
    setDeleteMultipleIsOpen(false);
  };
  const editUser = (User) => {
    let UserObject = JSON.stringify(User);
    let UserBase64 = Buffer.from(UserObject).toString("base64");
    window.localStorage.setItem("UserToEdit", UserBase64);
    document.getElementById("editUser-btn").click();
  };
  // The two following functions handle icon rotation for the ViewAll button based
  // on their ID which is their index in the array from which they are mapped
  // plus the string "-trigger"
  // The open and close states are added and removed ass classNames to apply the state
  const addOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.add("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_less");
  };
  const removeOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.remove("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_all");
  };
  const displayUserRoles = (User) => {
    let Roles = [...User.roles];
    let TriggerItems = []; // The first 4 items
    let Rest = []; // The remaining of the items if there is any (these items will be displayed inside the collapsible area)
    for (let i = 0; i < 4; i++) {
      TriggerItems.push(Roles[i]);
    }
    for (let i = 4; i < Roles.length; i++) {
      Rest.push(Roles[i]);
    }
    if (User.roles.length <= 4) {
      return (
        <React.Fragment>
          {User.superAdmin ? <p className="small-chip">Superadmin</p> : null}
          {User.roles.map((Role) => (
            <React.Fragment>
              {Role.deleted ? null : <p className="small-chip">{Role.name}</p>}
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    } else {
      return (
        <Collapsible
          onOpening={() => addOpenState(User.id)}
          onClosing={() => removeOpenState(User.id)}
          trigger={
            <section className="chip-holder">
              {User.superAdmin ? (
                <p className="small-chip">Superadmin</p>
              ) : null}
              {TriggerItems.map((RoleItem) => (
                <React.Fragment>
                  {RoleItem === undefined ? null : (
                    <p className="small-chip">{RoleItem.name}</p>
                  )}
                </React.Fragment>
              ))}
              <button className="trig-more">
                <p id={User.id + "-trigger-text"}>
                  {translateText("view_all")}
                </p>
                <img
                  className="trigger-icon-closed"
                  id={User.id + "-trigger"}
                  alt=""
                  src={Up}
                />
              </button>
            </section>
          }
        >
          <section className="chip-holder">
            {Rest.map((Role) => (
              <p className="small-chip">{Role.name}</p>
            ))}
          </section>
        </Collapsible>
      );
    }
  };

  const deselectCheckboxes = () => {
    document.getElementById("delete-btn").classList.add("disabled");
    document.getElementById("checkbox-all").checked = false;
    for (let i = 0; i < SelectedItems.length; i++) {
      document.getElementById("checkbox-" + SelectedItems[i]).checked = false;
    }
    setSelectedItems([]);
  };

  const requestPageNumber = (PageNumber) => {
    deselectCheckboxes();
    let NewStart = parseInt((PageNumber - 1) * SelectedSize);
    document.getElementById("Start").value = NewStart;
    document.getElementById("PrevId").value = PageNumber + "-page-btn";
    setPrevId(PageNumber + "-page-btn");
    updatePaginationActiveClass(document.getElementById("PrevId").value);
    setStart(NewStart);

    getFilteredData(SelectedSize, SelectedProfiles);
    if (PageNumber === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === Pages.length) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updatePaginationActiveClass = (CurrentId) => {
    if (document.getElementById("1-page-btn") !== null) {
      if (PrevId.length === 0 || PrevId === CurrentId) {
        document.getElementById("1-page-btn").classList.remove("active-page");
        if (document.getElementById(CurrentId)) {
          document.getElementById(CurrentId).classList.add("active-page");
        }
      } else {
        if (document.getElementById(PrevId) !== null) {
          document.getElementById(PrevId).classList.remove("active-page");
        }
        if (document.getElementById(CurrentId)) {
          document.getElementById(CurrentId).classList.add("active-page");
        }
      }
    } else {
      getFilteredData(SelectedSize, SelectedProfiles);
    }
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
    if (NextPage > 1 && Pages.length > 1) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
    if (PrevPage === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
  };
  const resetFilters = () => {
    if (document.getElementById("ACL-clear") !== null) {
      document.getElementById("ACL-clear").click();
    }
    if (document.getElementById("Status-clear") !== null) {
      document.getElementById("Status-clear").click();
    }
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    getFilteredData(SelectedSize, []);
  };
  const validateMessageAllEntries = () => {
    let Subject = document.getElementById("message-all-subject").value;
    let Message = document.getElementById("message").value;
    if (Subject.length === 0 || Message.length === 0) {
      if (Subject.length === 0) {
        document
          .getElementById("message-all-subject-label-holder")
          .classList.add("wrong");
      }
      if (Message.length === 0) {
        document
          .getElementById("message-textarea-holder")
          .classList.add("wrong");
      }
    } else {
      sendMessageToAll(Subject, Message);
    }
  };
  const sendMessageToAll = (Subject, Message) => {
    let MessageObj = {
      subject: Subject,
      description: Message,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/message/bulk",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: MessageObj,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMessageToAllIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const handleDisabledCheckboxChange = (Id) => {
    if (document.getElementById(Id).checked) {
      document.getElementById(Id).checked = false;
    }
  };
  const setSize = () => {
    setTimeout(async () => {
      if (document.getElementById("1-page-btn") !== null) {
        await setSelectedSize(
          parseInt(
            document.getElementById("pre-selected-row-per-page").innerHTML
          )
        );
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };
  return (
    <div className="main-content security-settings user-management">
      <input className="hidden" type="number" id="Start" />
      <input
        className="hidden"
        type="number"
        id="Status"
        value="0"
        max="2"
        min="0"
      />
      <input className="hidden" id="PrevId" defaultValue="1-page-btn" />
      <DesktopOnlyOverlay LangData={props.LangData} />
      {DeleteIsOpen ? (
        <DeleteAlert
          acceptDelete={() => acceptDelete()}
          cancelDelete={() => cancelDelete()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteMultipleIsOpen ? (
        <MultipleDeleteAlert
          acceptDeleteMultiple={() => acceptDeleteMultiple()}
          cancelDeleteMultiple={() => cancelDeleteMultiple()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {MessageToAllIsOpen ? (
        <MessageModal
          closeMessage={() => setMessageToAllIsOpen(false)}
          removeError={() => removeError("message-all-subject-label-holder")}
          validateMessageEntries={() => validateMessageAllEntries()}
          LangData={props.LangData}
        />
      ) : null}
      {SendMessageIsOpen ? (
        <div
          className={
            window.localStorage.getItem("MenuIsOpen") === "1"
              ? "overlay"
              : "overlay overlay-big"
          }
        >
          <div onClick={() => closeMessage()} className="outline"></div>
          <div className="message-modal">
            <div className="modal-header">
              <img
                onClick={() => closeMessage()}
                alt=""
                className="close"
                src={Close}
              />
              <h3 className="modal-title">{translateText("send_message")}</h3>
              <p className="recipient-name">{UserToContact.name}</p>
            </div>
            <div className="subject-holder">
              <TextInput
                Id="message-subject"
                PlaceHolder={translateText("subject")}
                ChangeEvent={() => removeError("message-subject-label-holder")}
                ValidationMessage="Please enter the subject."
              />
            </div>
            <div className="message-holder" id="message-holder">
              <TextArea
                Id="message"
                PlaceHolder={translateText("write_your_message") + " ..."}
                ChangeEvent={() => removeError("message-textarea-holder")}
                ClassName={"message-input"}
                ValidationMessage="Please enter the message."
              />
            </div>
            <section className="btn-group">
              <button onClick={() => closeMessage()} className="cancel">
                {translateText("cancel")}
              </button>
              <button
                onClick={() => validateMessageEntries()}
                className="submit"
              >
                {translateText("submit")}
              </button>
            </section>
          </div>
        </div>
      ) : null}
      <Header PageName={translateText("user_management")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("security_settings")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("user_management")}</p>
        </div>
      </div>
      <div className="actions">
        <section className="button-group button-group-flex">
          <button
            onClick={() => deleteMultipleItems()}
            id="delete-btn"
            className="act disabled"
          >
            <i className="feather-trash"></i>
            <p>{translateText("delete")}</p>
          </button>
          <button
            onClick={() => setMessageToAllIsOpen(true)}
            id="message-all-btn"
            className="act"
          >
            <img alt="" src={MessageIcon} className="small-btn-icon" />
            <p>{translateText("message_to_all")}</p>
          </button>
        </section>
        <NavLink to="/addUser">
          <button className="add-user">
            <img alt="" src={Plus} /> <p>{translateText("add_user")}</p>
          </button>
        </NavLink>
      </div>
      <div className="filters">
        <p className="title-text">{translateText("filters")}</p>
        <div className="flex">
          <SearchInput
            filterByNameLike={() => filterByNameLike()}
            ChangeHandler={(e) => updateSearchState(e)}
            clearSearch={() => clearSearch()}
            PlaceHolder={translateText("identity_search_placeholder")}
            Id="search"
          />

          <MultiSelect
            Initial={translateText("security_profile")}
            Options={Profiles}
            IsWithId
            Id="ACL"
            ChangeHandler={() => handleListByProfile()}
          />

          <MultiSelect
            Name={translateText("status")}
            Initial={"All Statuses"}
            Options={[translateText("active"), translateText("inactive")]}
            Id="Status"
            ChangeHandler={() => handleListByStatus()}
          />
        </div>
      </div>
      <div className="information">
        <div className="data-table">
          <section className="table-header flex">
            <div className="xsmall">
              <label className="blue-checkbox-rounded-label">
                <input
                  onChange={() => checkAll()}
                  type="checkbox"
                  id="checkbox-all"
                  class="blue-checkbox"
                />
                <i className="check-all"></i>
              </label>
            </div>
            <div className="medium username">{translateText("username")}</div>
            <div className="medium identity">
              <TableFilter
                className="large with-padding-left sorts"
                Name={translateText("identity")}
                Id="Identity"
                IsActive
                ChangeEvent={() => filterByName()}
              />
            </div>
            <div className="large profile">
              {translateText("assigned_profile")}
            </div>
            <div className="medium status">
              <TableFilter
                className="large with-padding-left sorts"
                Name={translateText("status")}
                Id="Status"
                ChangeEvent={() => filterByStatus()}
              />
            </div>
          </section>
          <React.Fragment>
            {Users.length === 0 ? null : (
              <div className="table-body">
                {Users.map((User) => (
                  <div className="table-item flex">
                    <div className="xsmall">
                      <>
                        {props.UserInfo.id === User.id ? (
                          <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
                            <input
                              onChange={() =>
                                handleDisabledCheckboxChange(
                                  "checkbox-" + User.id
                                )
                              }
                              type="checkbox"
                              class="blue-checkbox disabled-checkbox"
                              id={"checkbox-" + User.id}
                            />
                            <i></i>
                          </label>
                        ) : (
                          <label className="blue-checkbox-rounded-label">
                            <input
                              onChange={() => handleItemSelect(User.id)}
                              type="checkbox"
                              class="blue-checkbox"
                              id={"checkbox-" + User.id}
                            />
                            <i></i>
                          </label>
                        )}
                      </>
                    </div>
                    <div className="medium username">{User.username}</div>
                    <div className="medium identity-body">
                      {User.firstName + " " + User.lastName}
                    </div>
                    <div className="large profiles profile">
                      {displayUserRoles(User)}
                    </div>
                    <div className="medium status status-body">
                      {User.enabled || User.enabled === null ? (
                        <React.Fragment>
                          <section className="active"></section>
                          <p>{translateText("active")}</p>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <section className="deactive"></section>
                          <p>{translateText("inactive")}</p>
                        </React.Fragment>
                      )}
                    </div>
                    <div className="more usermanagement-more">
                      <button
                        onClick={() => openModal(User.id)}
                        className="btn-more"
                      ></button>
                      <div className="modal-space" id={"modal-" + User.id}>
                        <div
                          className="outline"
                          onClick={() => openModal(ModalPrevId)}
                        ></div>
                        {User.id === UserUUID ? (
                          <div className="modal-body-disabled">
                            <NavLink id="editUser-btn" to="/editUser"></NavLink>
                            <button onClick={() => null} className="btn">
                              <img alt="" src={Pencil} />
                              <div className="btn-text">
                                <p>{translateText("edit")}</p>
                                <p>{translateText("edit_user")}</p>
                              </div>
                            </button>
                            <button onClick={() => null} className="btn">
                              <img alt="" src={Chat} />
                              <div className="btn-text">
                                <p>{translateText("message")}</p>
                                <p>{translateText("send_message")}</p>
                              </div>
                            </button>
                            <button className="btn">
                              <img alt="" src={Delete} />
                              <div onClick={() => null} className="btn-text">
                                <p>{translateText("delete")}</p>
                                <p>{translateText("delet_user_permenantly")}</p>
                              </div>
                            </button>
                          </div>
                        ) : (
                          <React.Fragment>
                            {User.superAdmin ? (
                              <React.Fragment>
                                {window.localStorage.getItem("IsSuperAdmin") ===
                                "1" ? (
                                  <div className="modal-body">
                                    <NavLink
                                      id="editUser-btn"
                                      to="/editUser"
                                    ></NavLink>
                                    <button
                                      onClick={() => editUser(User)}
                                      className="btn"
                                    >
                                      <img alt="" src={Pencil} />
                                      <div className="btn-text">
                                        <p>{translateText("edit")}</p>
                                        <p>{translateText("edit_user")}</p>
                                      </div>
                                    </button>
                                    <button
                                      onClick={() =>
                                        openMessage(
                                          User.id,
                                          User.firstName + " " + User.lastName,
                                          User.email
                                        )
                                      }
                                      className="btn"
                                    >
                                      <img alt="" src={Chat} />
                                      <div className="btn-text">
                                        <p>{translateText("message")}</p>
                                        <p>{translateText("send_message")}</p>
                                      </div>
                                    </button>
                                    <button className="btn">
                                      <img alt="" src={Delete} />
                                      <div
                                        onClick={() => toggleDeleteSingle(User)}
                                        className="btn-text"
                                      >
                                        <p>{translateText("delete")}</p>
                                        <p>
                                          {translateText(
                                            "delet_user_permenantly"
                                          )}
                                        </p>
                                      </div>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="modal-body-disabled">
                                    <NavLink
                                      id="editUser-btn"
                                      to="/editUser"
                                    ></NavLink>
                                    <button
                                      onClick={() => null}
                                      className="btn"
                                    >
                                      <img alt="" src={Pencil} />
                                      <div className="btn-text">
                                        <p>{translateText("edit")}</p>
                                        <p>{translateText("edit_user")}</p>
                                      </div>
                                    </button>
                                    <button
                                      onClick={() => null}
                                      className="btn"
                                    >
                                      <img alt="" src={Chat} />
                                      <div className="btn-text">
                                        <p>{translateText("message")}</p>
                                        <p>{translateText("send_message")}</p>
                                      </div>
                                    </button>
                                    <button className="btn">
                                      <img alt="" src={Delete} />
                                      <div
                                        onClick={() => null}
                                        className="btn-text"
                                      >
                                        <p>{translateText("delete")}</p>
                                        <p>
                                          {translateText(
                                            "delet_user_permenantly"
                                          )}
                                        </p>
                                      </div>
                                    </button>
                                  </div>
                                )}
                              </React.Fragment>
                            ) : (
                              <div className="modal-body">
                                <NavLink
                                  id="editUser-btn"
                                  to="/editUser"
                                ></NavLink>
                                <button
                                  onClick={() => editUser(User)}
                                  className="btn"
                                >
                                  <img alt="" src={Pencil} />
                                  <div className="btn-text">
                                    <p>{translateText("edit")}</p>
                                    <p>{translateText("edit_user")}</p>
                                  </div>
                                </button>
                                <button
                                  onClick={() =>
                                    openMessage(
                                      User.id,
                                      User.firstName + " " + User.lastName,
                                      User.email
                                    )
                                  }
                                  className="btn"
                                >
                                  <img alt="" src={Chat} />
                                  <div className="btn-text">
                                    <p>{translateText("message")}</p>
                                    <p>{translateText("send_message")}</p>
                                  </div>
                                </button>
                                <button className="btn">
                                  <img alt="" src={Delete} />
                                  <div
                                    onClick={() => toggleDeleteSingle(User)}
                                    className="btn-text"
                                  >
                                    <p>{translateText("delete")}</p>
                                    <p>
                                      {translateText("delet_user_permenantly")}
                                    </p>
                                  </div>
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </React.Fragment>
        </div>
        {ResultIsEmpty ? (
          <div className="empty-state">
            <img alt="" src={EmptyState} />
            <p>{translateText("security_profiles_empty_state")}</p>
            <button onClick={() => resetFilters()}>
              {translateText("reset_filters")}
            </button>
          </div>
        ) : (
          <div className="page-footer">
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className="page-btn page-btn-disabled"
              >
                <i className="feather-chevron-left"></i>
              </button>
              <React.Fragment>
                {Pages.length < 6 ? (
                  <React.Fragment>
                    {Pages.map((Page) => (
                      <React.Fragment>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </React.Fragment>
                )}
              </React.Fragment>
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn"
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <p className="small-info-footer">
              {translateText("showing")} {Start + 1} {translateText("to")}{" "}
              {Start + SelectedSize <= TotalElements
                ? Start + SelectedSize
                : TotalElements}{" "}
              {translateText("of")} {TotalElements} {translateText("items")}.
            </p>
            <PaginationRowSelector
              SizeOptions={SizeOptions}
              setSize={() => setSize()}
              LangData={props.LangData}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default UserManagement;
